import { BOARD_HEIGHT, BOARD_WIDTH } from "../game/constants/board";

export function GameCanvas({ controller }) {
	const { canvasRef, actions, ui } = controller;

	return (
		<div className="battlefield-stack">
			<section className="battlefield" aria-label="Stellar Siege battlefield">
				<canvas
					ref={canvasRef}
					className="battlefield__canvas"
					width={BOARD_WIDTH}
					height={BOARD_HEIGHT}
					onPointerDown={actions.onCanvasPointerDown}
					onPointerMove={actions.onCanvasPointerMove}
					onPointerUp={actions.onCanvasPointerUp}
					onPointerCancel={actions.onCanvasPointerCancel}
					onPointerLeave={actions.onCanvasPointerLeave}
					onWheel={actions.onCanvasWheel}
				/>
				{ui.paused && <div className="battlefield__pause">PAUSED</div>}
				{ui.notice && <div className={`toast toast--${ui.notice.tone}`}>{ui.notice.message}</div>}
			</section>
			{ui.notice && <div className={`mobile-game-notice toast toast--${ui.notice.tone}`}>{ui.notice.message}</div>}
		</div>
	);
}
